import { LocalStorageKeys } from '@/constants/localstorage'
import { getUserScopedItem } from '@/utils/userScopedStorage'

import { Logger } from '@/components/Logger'
const sounds = {
  input: new Audio('/assets/sounds/input.mp3'),
  switchTab: new Audio('/assets/sounds/switch-tab.mp3'),
  createOrder: new Audio('/assets/sounds/create-order.mp3'),
  cancelOrder: new Audio('/assets/sounds/cancel-order.mp3'),
  orderFilled: new Audio('/assets/sounds/order-filled.mp3'),
}

export const playSound = (sound: keyof typeof sounds) => {
  if (sounds[sound] && getUserScopedItem(LocalStorageKeys.SOUND_ON) === 'true') {
    sounds[sound].currentTime = 0 // Reset sound to start
    sounds[sound].play().catch((error) => {
      Logger.error(`Error playing sound ${sound}:`, error)
    })
  }
}
